<template>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <h4 class="header-title mb-4"><h4 class="page-title">{{$t('string.msg.model.list.label.title')}}</h4></h4>
                <div class="table-responsive">
                    <table class="table table-centered table-hover mb-0" id="datatable">
                        <thead>
                            <tr>
                                <th class="border-top-0">{{$t('string.msg.product.family.label.name')}}</th>
                                <th class="border-top-0">{{$t('string.msg.product.family.label.type')}}</th>
                                <th class="border-top-0">{{$t('string.msg.product.family.label.status')}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-bind:key="item._id" v-for="item in items" class="cursor-pointer" @click="selectItem(item)">
                                <td>
                                    <i class=" mdi mdi-upload"></i>
                                    <span class="ml-2">
                                        {{camelize(item.name)}}
                                    </span>
                                </td>
                                <td>
                                    <span v-if="item.type=='TRUCK'">
                                        {{$t('string.msg.model.type.truck')}}
                                    </span>
                                    <span v-if="item.type=='TRUCK_TRAILER'">
                                        {{$t('string.msg.model.type.truck-trailer')}}
                                    </span>
                                </td>
                                <td>
                                    <span 
                                    v-bind:class="{ 'badge-success': item.status == 'ACTIVE', 'badge-danger': item.status == 'ARCHIVED' }" 
                                    class="badge badge-pill ">
                                    
                                        {{$t(`string.msg.status.${item.status}`)}}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import Controller from './CrtListModel';
import Spinner from '../../../components/layout/Spinner';
import Toast from '../../../components/layout/Toast';

export default {
  name: 'ListGroups',
  props: ["valuekey"],
    watch:{
        'valuekey'(){
        }
    },
  components: {
    Spinner,
    Toast
  },
  data() {
      return {
        errors: [],
        titleToast: null,
        messageToast: null,
        messageIdToast: null,
        items: []
      }
  },
  methods: Controller.methods,
  created() {
    Controller.init(this);
    let state = this;
    this.$eventHub.$on('refreshList', function(){
        state.filter();
    })
  },
  mounted(){
  }
}
</script>

<style>
</style>
